// @core/api/endpoints/affiliate/list_postbacks.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListPostbacksResponse,
} from '../../../types/affiliate';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/affiliate';

/**
 * List postbacks for offer
 * Returns a paginated list of postbacks. Supports filtering and sorting.
 */
export async function ListPostbacks(
  offer_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListPostbacksResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/offers/:offer_id/postbacks`;
  requestPath = requestPath.replace(':offer_id', encodeURIComponent(offer_id));
  const requestOptions = options;
  return client.get<ListPostbacksResponse>(requestPath, { ...requestOptions, params });
}
